import * as RadixTabs from '@radix-ui/react-tabs';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type AssetModalRightPanelOpenTab } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';

export type InfoPanelTabsContentProps = Omit<RadixTabs.TabsContentProps, 'value'> & {
  side?: 'left' | 'right';
  value: AssetModalRightPanelOpenTab;
};

export const InfoPanelTabsContent = memo(
  ({ className, side = 'left', value, ...restProps }: InfoPanelTabsContentProps) => {
    return (
      <RadixTabs.Content
        data-tab-id={value}
        data-side={side}
        data-testid="INFO_PANEL_TABS_CONTENT"
        className={cn(
          'absolute inset-0 size-full overflow-y-auto px-4',
          'data-[state=active]:fade-in-0 data-[state=active]:animation-ease-in-out data-[state=active]:animate-in data-[state=active]:duration-300',
          side === 'left'
            ? 'data-[state=active]:slide-in-from-left-full data-[state=inactive]:slide-out-to-left-full'
            : 'data-[state=active]:slide-in-from-right-full data-[state=inactive]:slide-out-to-right-full',
          'data-[state=inactive]:fade-out-0 data-[state=inactive]:animation-ease-in-out data-[state=inactive]:animate-out data-[state=inactive]:duration-300',
          className,
        )}
        value={value}
        {...restProps}
      />
    );
  },
);

InfoPanelTabsContent.displayName = 'InfoPanelTabsContent';
